import { User } from './../../shared/models/user.model';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Router } from '@angular/router';
import { UsersService } from './../../shared/services/users.service';
import { Component, Injector, OnInit } from '@angular/core';
import { EncodeData } from 'src/app/shared/models/encode.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent extends BaseListComponent<User> {
 
    constructor(
      public usersServ:UsersService,
      public injector:Injector,
      public auth:AuthService,
      public toastr:ToastrManager,
    ){
      super(usersServ, injector, 'userr', {editUrl:'/admin/users/edit', createUrl:'/admin/users/new',detailUrl:'/admin/users/detail'});
    }
  
    // unimplemented method
    protected initChildProprieties(): void {}
    
    
    // unimplemented method
    protected initChildMethods(): void {}
  
    tableProprieties(): string[] {
      const columns=[
        'Nome',
        'Email',
        'Clube/Entidade',
        'Perfil',
      ];

      if(!this.isAdminOrUserKhuzela()) columns.splice(2,1);

      return columns;
    }

}
